import { Link } from "react-router-dom";

export default function WikiLanding() {
  const cards = [
    {
      to: "/qa",
      title: "Q&A",
      description: "Find answers and relevant documents instantly.",
      accent: "from-amber-500/20 to-orange-500/20",
      ring: "group-hover:border-amber-400/60 dark:group-hover:border-amber-500/60",
    },
    {
      to: "/rfp-feeder",
      title: "RFP Analizer",
      description: "Tool to analize RFPs and to validate its compliance.",
      accent: "from-emerald-500/20 to-teal-500/20",
      ring: "group-hover:border-emerald-400/60 dark:group-hover:border-emerald-500/60",
    },
    {
      href: "https://workflow.radwarelatam.com/form/estimado-mbps",
      title: "CWAF Sizing",
      description: "Tool to Estimate the BW in Mbps from the given applications.",
      accent: "from-violet-500/20 to-indigo-500/20",
      ring: "group-hover:border-violet-400/60 dark:group-hover:border-violet-500/60",
    },
    {
      href: "http://autoreport.radwarelatam.com/",
      title: "Auto Report",
      description: "Open the Auto Report tool.",
      accent: "from-sky-500/20 to-cyan-500/20",
      ring: "group-hover:border-sky-400/60 dark:group-hover:border-sky-500/60",
    },
    {
      href: "http://172.30.4.125/",
      title: "95% calculator",
      description: "Tool to calculate de 95% based on the CSV exported from the page",
      accent: "from-rose-500/20 to-fuchsia-500/20",
      ring: "group-hover:border-rose-400/60 dark:group-hover:border-rose-500/60",
    },
    {
      href: "http://172.30.4.125:8000/",
      title: "Cloud Domain Checker",
      description: "Tool to validate if customer is diverted to our Cloud or to a Different one.",
      accent: "from-blue-500/20 to-cyan-500/20",
      ring: "group-hover:border-blue-400/60 dark:group-hover:border-blue-500/60",
    },
    {
      href: "http://172.30.4.175:3014/",
      title: "BOM Builder",
      description: "Chat to build a priced bill of materials from the NA price list.",
      accent: "from-lime-500/20 to-emerald-500/20",
      ring: "group-hover:border-lime-400/60 dark:group-hover:border-lime-500/60",
    },
  ];

  return (
    <div className="w-full">
      <section className="relative mb-8 overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900/80 sm:p-8">
        <div className="relative">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
            Radware Wiki · Workspace Home
          </p>
          <h1 className="mb-3 text-3xl font-semibold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
            Ask. Explore. Build.
          </h1>
          <p className="max-w-3xl text-base text-slate-600 dark:text-slate-300 sm:text-lg">
            Your technical knowledge, AI-powered insights, and engineering tools — all in one workspace.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Quick actions</h2>
          <span className="text-xs text-slate-500 dark:text-slate-400">Optimized for daily backoffice workflows</span>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          {cards.map((card) => {
            const className = `group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md dark:border-slate-700 dark:bg-slate-900/80 ${card.ring}`;
            const body = (
              <>
                <div className={`pointer-events-none absolute inset-x-0 top-0 h-16 bg-gradient-to-r ${card.accent}`} />
                <div className="relative flex h-full flex-col pt-1">
                  <h3 className="mb-2 text-base font-semibold text-slate-900 dark:text-white">{card.title}</h3>
                  <p className="mb-4 mt-4 min-h-[3.25rem] flex-1 text-sm text-slate-600 dark:text-slate-300">{card.description}</p>
                  <span className="inline-flex items-center rounded-md border border-slate-300 bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700 transition group-hover:border-blue-400 group-hover:text-blue-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:group-hover:border-blue-500 dark:group-hover:text-blue-300">
                    Open
                  </span>
                </div>
              </>
            );
            if (card.href) {
              return (
                <a
                  key={card.href}
                  href={card.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={className}
                >
                  {body}
                </a>
              );
            }
            return (
              <Link key={card.to} to={card.to} className={className}>
                {body}
              </Link>
            );
          })}
        </div>
      </section>

      <section className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-300 sm:p-5">
        Need document operations? The document library remains available via direct route.
      </section>
    </div>
  );
}

